import {
	Box, IconButton, useColorModeValue
} from '@chakra-ui/react';
import { renderThumb, renderTrack, renderView } from 'components/scrollbar/Scrollbar';
import Content from 'components/sidebar/components/Content';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { useContext } from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import { useLocation } from 'react-router-dom';
import { SidebarContext } from 'utils/contexts/SidebarContext';
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED } from 'utils/constants';

function Sidebar(props: { routes: RoutesType[];[x: string]: any }) {
	const { routes } = props;
	const location = useLocation();
	const currentLayout = `/${location.pathname.split('/')[1]}`;
	const filteredRoutes = routes.filter(route => route.hidden !== true && route.layout === currentLayout);
	const { isCollapsed, setIsCollapsed } = useContext(SidebarContext);

	let variantChange = '0.2s linear';
	let shadow = useColorModeValue('14px 17px 40px 4px rgba(112, 144, 176, 0.08)', 'unset');
	let sidebarBg = useColorModeValue('white', 'navy.800');
	let sidebarMargins = '0px';
	let toggleBg = useColorModeValue('white', 'navy.700');
	let toggleBorder = useColorModeValue('gray.200', 'whiteAlpha.200');

	const sidebarWidth = isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;

	// SIDEBAR
	return (
		<Box display='block' position='fixed' minH='100%' zIndex='100'>
			<Box position='relative' w={`${sidebarWidth}px`} transition={variantChange}>
				<Box
					bg={sidebarBg}
					transition={variantChange}
					w={`${sidebarWidth}px`}
					h='100vh'
					m={sidebarMargins}
					minH='100%'
					overflowX='hidden'
					boxShadow={shadow}>
					<Scrollbars
						autoHide
						renderTrackVertical={renderTrack}
						renderThumbVertical={renderThumb}
						renderView={renderView}>
						<Content routes={filteredRoutes} isCollapsed={isCollapsed} />
					</Scrollbars>
				</Box>
				<IconButton
					aria-label={isCollapsed ? 'Espandi il menu' : 'Riduci il menu'}
					icon={isCollapsed ? <MdChevronRight size={18} /> : <MdChevronLeft size={18} />}
					onClick={() => setIsCollapsed(!isCollapsed)}
					position='absolute'
					top='18px'
					right='-14px'
					size='sm'
					minW='28px'
					h='28px'
					borderRadius='full'
					bg={toggleBg}
					border='1px solid'
					borderColor={toggleBorder}
					boxShadow={shadow}
					zIndex={3}
					_hover={{ bg: toggleBg }}
					_focus={{ boxShadow: 'none' }}
				/>
			</Box>
		</Box>
	);
}

export default Sidebar;
